module.exports = __webpack_public_path__ + "images/emoji/left_luggage.81928248773996ae259f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/left_luggage.png
// module id = 0NN5
// module chunks = 24